<template>
  <div>
    <div class="flex flex-col w-full rounded shadow-lg px-4 py-6 bg-white job-details__wrapper">
      <div class="flex flex-col items-center md:items-start md:flex-row widget-job-details__header">
        <div class="justify-between w-auto sm:w-64 md:w-auto p-4 items-start widget-job-details_image__wrapper">
          <div class="md:mr-4 widget-job-details_image">
            <img :src="job.logo"
                 class="self-start md:self-center rounded p-2 border-2 border-solid border-lightgray"
                 alt="jobImage"/>
          </div>
        </div>
        <div class="flex flex-col items-center md:items-start w-full my-2 widget-job-details_info__wrapper">
          <div class="flex flex-row justify-center w-full md:justify-between widget-job-details_info">
            <span class="mt-1 font-semibold text-black">
                {{job.organisation_name}}
            </span>
            <div class="not-visible items-center flex-row md:flex widget-job-details-card_time__wrapper">
              <div class="flex flex-row items-center mb-1 widget-job-details-card_time">
                <clock-icon size="1x" class="mr-1 cursor-pointer clock-icon"></clock-icon>
                <span class="text-sm text-gray">{{daysAgo(job.from)}}</span>
              </div>
            </div>
          </div>
          <div class="flex flex-row flex-wrap justify-start w-full my-2 text-normal widget-job-details-card-details__wrapper">
            <div class="w-full flex justify-center md:justify-start widget-job-details-card_details">
              <span class="self-start text-2xl font-bold text-black overflow-hidden"
                    :to="`/${job.slug}`">
                  {{job.title}}
              </span>
            </div>
            <div v-if="job.salary_min"
                 class="flex flex-row w-full justify-center md:justify-start items-center mt-1 widget-job-details-card-salary__wrapper">
              <div class="flex items-center mr-3 widget-job-details-job_location">
                <map-pin-icon size="1x" class="mr-1 cursor-pointer location-icon"></map-pin-icon>
                {{job.location_name}}
              </div>
              <div class="flex widget-job-details-job_salary">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wallet"
                     class="svg-inline--fa fa-wallet fa-w-16 w-4 mr-2"
                     role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="var(--color-primary)"
                        d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"></path>
                </svg>
                <span>€{{job.salary_min}} - €{{job.salary_max}}</span>
              </div>
            </div>
            <div class="w-full job-card__time mt-2 md:hidden widget-job-details-job_time__wrapper">
              <div class="flex justify-center items-center w-ful widget-job-details-job_time">
                <clock-icon size="1x" class="mr-1 cursor-pointer clock-icon"></clock-icon>
                <span>{{this.$t('common.published')}}: {{daysAgo(job.from)}} {{this.$t('common.ago')}}</span>
              </div>
            </div>
          </div>

          <div class="flex-row flex-wrap not-visible md:flex widget-job-details-job_segments__wrapper">
            <div v-for="(segment, index) in segmentsText" :key="index"
                 class="rounded-full text-xs py-1 px-3 mt-2 mr-2 text-xs text-primary-darker font-semibold bg-primary-lighter cursor-pointer segment-tag widget-job-details-job_segments">
              <p>{{segment.value}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 flex flex-col md:flex-row justify-center md:justify-start items-center widget-job-details_job-apply-button__wrapper">
        <a v-if="job.apply_url"
           class="py-2 text-center px-4 mx-3 mt-4 w-full sm:w-7/12 md:w-full rounded-lg cursor-pointer bg-primary shadow-lg text-white text-base font-semibold widget-job-details_job-apply_button"
           :href="job.apply_url"
           @click="sendAnalytics">
          {{$t('common.applyNow')}}
        </a>
        <el-button
          v-else
          class="py-3 px-4 mx-3 mt-4 w-full sm:w-7/12 md:w-full rounded-lg cursor-pointer bg-primary shadow-lg text-white text-base font-semibold widget-job-details_job-apply_button"
          @click="applyJob">
          {{this.$t('common.applyNow')}}
        </el-button>
        <el-button
          class="inline-flex items-center justify-center w-full sm:w-3/6 md:w-full py-3 px-4 mx-3 mt-4 rounded-lg cursor-pointer shadow-lg text-white text-base font-medium gradient-button widget-job-details_job-share_button"
          @click="shareJob">
          <share-icon size="1x" class="mr-1 custom-class"></share-icon>
          {{this.$t('common.share')}}
        </el-button>
      </div>
    </div>
    <div v-html="job.text_own" ref="textOwn"
         class="w-full mt-4 rounded shadow-lg text-sm md:text-base py-4 px-3 md:py-8 md:px-12 bg-white whitespace-pre-line job-description__pre"></div>
    <div class="flex flex-row justify-center mt-4 widget-job-details_job-apply_button__wrapper">
      <a v-if="job.apply_url"
         :href="job.apply_url"
         @click="sendAnalytics"
         class="py-2 text-center px-4 mx-3 mt-4 w-full sm:w-7/12 md:w-full rounded-lg cursor-pointer bg-primary shadow-lg text-white text-base font-semibold widget-job-details_job-apply_button_lower">
        {{$t('common.applyNow')}}
      </a>
      <el-button
        v-else
        class="py-3 px-4 mx-3 mt-4 w-2/4 rounded-lg cursor-pointer bg-primary shadow-lg text-white text-base font-semibold widget-job-details_job-apply_button_lower"
        @click="applyJob">
        {{this.$t('common.applyNow')}}
      </el-button>
    </div>
    <img :src="pixelUrls.view" class="tracking-pixel-img"/>
  </div>
</template>

<script>
  import { ClockIcon, MapPinIcon, ShareIcon } from 'vue-feather-icons'
  import { formatDistance, subDays } from 'date-fns'
  import { TRACKING_EVENTS } from '../enum/tracking'
  import { enUS, nl } from 'date-fns/locale'

  const locales = { enUS, nl }

  export default {
    name: 'job-item',
    components: {
      ClockIcon,
      MapPinIcon,
      ShareIcon
    },
    props: {
      job: {
        type: Object,
        default: () => ({})
      },
      segments: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currentLanguage: ''
      }
    },
    mounted() {
      this.currentLanguage = this.$store.getters['getCurrentLanguage']
      this.registerAnchorListeners()
    },
    computed: {
      segmentsText() {
        let { segments } = this.job
        const allSegments = []

        if (!segments) {
          return
        }

        for (const category in segments) {
          const categorySegments = segments[category]
          categorySegments.forEach(segmentId => {
            const segmentInfo = this.$store.getters['getSegmentsById'][segmentId]
            if (segmentInfo) {
              allSegments.push(segmentInfo)
            }
          })
        }
        return allSegments.slice(0, 5)
      },
      pixelUrls() {
        const config = this.$store.getters['widgetConfig']
        const pixelUrl = `${config.BASE_URL}/api/public/v1/event/${this.job.uuid}`

        return {
          applyStart: pixelUrl + '/apply_start.png',
          view: pixelUrl + '/view.png',
          clickOut: pixelUrl + '/click_out.png'
        }
      },
    },
    methods: {
      daysAgo(created) {
        if (!created) {
          return
        }
        try {
          const validFormat = created.replace(/ /g,"T")
          const createdDate = new Date(validFormat)
          const now = new Date()
          const locale = locales[this.currentLanguage]
          return formatDistance(subDays(createdDate, 0), now, { locale: locale })
        } catch (e) {
          return '--'
        }
      },
      shareJob() {
        this.$emit('shareJob')
      },
      sendAnalytics() {
        this.$analytics(TRACKING_EVENTS.JOB_APPLY_START, {
          eventLabel: this.job.apply_url ? this.job.apply_url : this.job.uuid,
          job: this.job,
          config: {
            externalLink: this.job.apply_url,
            pixelUrl: this.pixelUrls.applyStart
          }
        })
      },
      applyJob() {
        this.$emit('applyJob')
        this.sendAnalytics()
      },
      registerAnchorListeners() {
        const { textOwn } = this.$refs
        let aTags = []

        if (textOwn) {
          aTags = textOwn.querySelectorAll('a')
        }

        for (let anchor of aTags) {
          anchor.addEventListener('click', this.onAnchorClick)
        }
      },
      onAnchorClick(event) {
        event.preventDefault()

        this.$analytics(TRACKING_EVENTS.OUTBOUND_LINK, {
          config: {
            pixelUrl: this.pixelUrls.clickOut,
            externalLink: true,
          },
          eventLabel: event.target.href,
          job: this.job
        })
      }
    }
  }
</script>
